import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { QQQuestionnaireViewModel } from '../models/qq-questionnaire.view-model';
import { QuickQuoteResult } from '../models/quick-quote-result';
import { getCookie, proccessCookie } from '../util/cookie-handler';

export interface IEventData {
  channel?: string;
  page?: string;
  quote_page?: string;
  page_title?: string;
  question?: string;
}

@Injectable({
  providedIn: 'root',
})
export class AnalyticsService {
  userAgent: string;
  constructor() { }

  logEvent(name: string, params?: IEventData) {
    name = "quote:" + name;

    if (!environment.production) {
      console.log('logEvent %o: %o', name, params);
    }
    try {
      const dataLayer = (<any>window).dataLayer;

      if (dataLayer) {
        dataLayer.push({ 'event': name, params });
      }
    }
    catch (e) {
    }
  }

  logPageView(page: string, params?: IEventData) {
    if (!params)
      params = {};

    this.logEvent('page_view', {
      ...params,
      page: this.getFullPath(page),
      quote_page: page
    });
  }

  getFullPath(page: string) {
    return location.origin + location.pathname + 'component:' + page;
  }

  logLead(quickQuote: QQQuestionnaireViewModel, result: QuickQuoteResult, page: string) {
    this.logEvent('lead', this.getLeadData(quickQuote, {
      page: this.getFullPath(page),
      amountPaid: result.premium,
      quoteNo: result.quoteNo,
      isFirstQuote: result.isFirstQuote
    }));
  }

  logLeadGen(quickQuote: QQQuestionnaireViewModel, page: string) {
    this.logEvent('lead', this.getLeadData(quickQuote, { page: this.getFullPath(page) }));
  }

  logDuplicateLeadGen(quickQuote: QQQuestionnaireViewModel, page: string) {
    this.logEvent('duplicate_lead', this.getLeadData(quickQuote, { page: this.getFullPath(page) }));
  }

  logFailedLead(quote: QQQuestionnaireViewModel) {
    this.logEvent('failed_application', this.getLeadData(quote));
  }

  private getLeadData(quote: QQQuestionnaireViewModel, data?: any) {
    const ansObj = quote.answersObject;
    if (!data)
      data = {};
    if (!data.uid)
      data.uid = ansObj['Uid'];

    data.leadType = quote.name == 'QuickQuote3' ? 'quickQuote' : quote.name;
    data.currency = 'GBP';
    data.firstName = ansObj['FirstPolicyHolderFirstName'];
    data.lastName = ansObj['FirstPolicyHolderSurName'];
    data.email = ansObj['FirstPolicyHolderEmail'];
    data.leadkey = quote.quoteKey;

    return data;
  }

  public mapTrackingData(): { key: string; value: string }[] {
    const ret: { key: string; value: string }[] = [];

    const trackingEvents = [
        { source: 'facebook', cookies: ['_fbc', '_fbp'] }
    ];

    for (const entry of trackingEvents) {
        for (const cookie of entry.cookies) { 
            const value = getCookie(cookie);
            if (value) {
                ret.push({ key: `${entry.source}${cookie}`, value }); 
            }
        }
    }
    
    const cookies = [
      { cookie: 'utm_params', keys: ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'] },
      { cookie: 'td_params', keys: ['tduid'] },
      { cookie: 'ss_params', keys: ['sskey'] },
      { cookie: 'fb_params', keys: ['fbclid'] }
    ];

    for (const entry of cookies) {
      const params = this.getParams(entry.keys, entry.cookie);
      if (params) {
        for (const key in params) {
          ret.push({ key, value: params[key] });
        }
      }
    }
    return ret;
  }

  public getParams(paramNames: string[], cookieName: string): { [key: string]: string } {
    const urlParams = new URLSearchParams(window.location.search);
    const params: { [key: string]: string } = {};
    if (urlParams) {
      paramNames.forEach((key) => {
        const value = urlParams.get(key);
        if (value && !params[key]) {
          params[key] = value;
        }
      });
    }

    const cookieParams = proccessCookie(cookieName, paramNames);
    if (cookieParams) {
      Object.keys(cookieParams).forEach((key) => {
        if (!params[key]) {
          params[key] = cookieParams[key];
        }
      });
    }
    return params;
  }

}